import React from 'react'

const Employer: React.FC = () => {
    return (
        <div>Employer</div>
    )
}

export default Employer;